/*
Display multiple dishes (like your design shows)
Be droppable (for now, just make it a styled Paper)
Show dish names as chips/badges
*/

import React, { useState } from "react";
import { Paper, Typography, Box, Chip } from "@mui/material";
import { useDroppable, useDraggable } from '@dnd-kit/core';
import DishEditDialog from '../../components/dishes/DishEditDialog';
import RestaurantIcon from '@mui/icons-material/Restaurant';

// Simplified draggable dish chip without delete icon
const DraggableDishChip = ({ dish, index, day, mealTime, onDishClick }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    isDragging,
  } = useDraggable({
    id: `plan-dish-${day}-${mealTime}-${index}`,
    data: {
      type: 'planDish',
      dish: dish,
      fromDay: day,
      fromMeal: mealTime,
      dishIndex: index
    }
  });

  const style = {
    transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <Chip
      ref={setNodeRef}
      style={style}
      {...listeners}
      {...attributes}
      label={dish.name}
      size="small"
      variant="filled"
      color={dish.type === 'restaurant' ? "warning" : "primary"}
      title={dish.description}
      onClick={(e) => {
        e.stopPropagation();
        onDishClick(dish);
      }}
      sx={{ 
        mb: 0.5, 
        mr: 0.5, 
        cursor: 'grab',
        '&:active': {
          cursor: 'grabbing'
        }
      }}
    />
  );
};

const MealCell = ({ day, date, mealTime, dishes = [], restaurants = [] }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedDish, setSelectedDish] = useState(null);

  const handleDishClick = (dish) => {
    setSelectedDish(dish);
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setSelectedDish(null);
    setDialogOpen(false);
  };

  const {
    isOver,
    setNodeRef
  } = useDroppable({
    id: `meal-${day}-${mealTime}`,
    data: {
      type: 'meal',
      day: day,
      mealTime: mealTime,
      date: date,
      accepts: ['dish', 'restaurant'] // Add this to indicate what types are accepted
    }
  });

  const style = {
    backgroundColor: isOver ? '#e3f2fd' : '#f5f5f5',
    border: isOver ? '2px dashed #2196f3' : '1px solid #ddd',
    minHeight: '80px'
  };

  return (
    <Paper
      ref={setNodeRef}
      style={style}
      sx={{ 
        p: 1,
        minHeight: '80px',
        display: 'flex',
        flexDirection: 'column',
        gap: 0.5
      }}
    >
      <Box>
        {dishes.map((dish, index) => (
          <DraggableDishChip
            key={index}
            dish={dish}
            index={index}
            day={day}
            mealTime={mealTime}
            onDishClick={handleDishClick}
          />
        ))}
      </Box>

      <DishEditDialog
        open={dialogOpen}
        dish={selectedDish}
        onClose={handleDialogClose}
        onSave={() => console.log('skip')}
        // onDelete={handleDelete}
        mode="display"
      />

      {(dishes.length === 0 && restaurants.length === 0) && (
        <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
          Drop dishes or restaurants here
        </Typography>
      )}
    </Paper>
  );
};

export default MealCell;